export { default } from './Title';